/**
 * Branded loading spinner component
 * @param {Object} props - Component props
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.size='md'] - Size variant (sm, md, lg)
 */
import React from 'react'
import PropTypes from 'prop-types'

const sizes = {
  sm: 'w-8 h-8',
  md: 'w-12 h-12',
  lg: 'w-16 h-16'
}

function LoadingSpinner({ className = '', size = 'md' }) {
  return (
    <img
      src="/photowhim_spinner.png"
      alt="Loading..."
      className={`animate-spin ${sizes[size]} ${className}`}
      style={{ animationDuration: '1s' }}
    />
  )
}

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string
}

export default LoadingSpinner 